import React, { Suspense, lazy } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import LandingPage from './pages/auth/LandingPage'
import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'
import RedirectToDefaultPlace from './components/RedirectToDefaultPlace'

const POSApp = lazy(() => import('./App'))

function ProtectedRoute({ children }: { children: React.ReactElement }) {
  const auth = useAuth()
  const location = useLocation()

  if (auth?.loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }

  if (!auth?.user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

function GuestOnlyRoute({ children }: { children: React.ReactElement }) {
  const auth = useAuth()

  if (auth?.loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }

  if (auth?.user) {
    return <Navigate to="/app" replace />
  }

  return children
}

export default function AuthShell() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/login"
        element={
          <GuestOnlyRoute>
            <LoginPage />
          </GuestOnlyRoute>
        }
      />
      <Route
        path="/register"
        element={
          <GuestOnlyRoute>
            <RegisterPage />
          </GuestOnlyRoute>
        }
      />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <RedirectToDefaultPlace />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/:placeId/*"
        element={
          <ProtectedRoute>
            <Suspense
              fallback={
                <div style={{ padding: '2rem', textAlign: 'center' }}>
                  Loading…
                </div>
              }
            >
              <POSApp />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
